import React from 'react';
import { connect } from 'dva';
import { createSelector } from 'reselect';

import { CITIZENSHIP, DocumentFields } from '../../../constants/document';
import Document, { DocumentProps } from '../../shared/Document/Document';
import { getApplicantDocument } from '../../../selectors/applicant';
import { getValue } from '../../../constants/getFieldValues';
import { ApplicantFields } from '../../../models/applicant';
import ApplicantDocumentWarning from './ApplicantDocumentWarning';
import { APPLICANT } from '../../../constants/modelNames';

const ApplicantDocument = (props: DocumentProps) => {
  return (
    <div className="Document">
      <Document {...props} />
      <ApplicantDocumentWarning />
    </div>
  );
};

const mapStateToProps: (state: {
  applicant: ApplicantFields;
}) => DocumentFields & {
  citizenship: CITIZENSHIP | null;
  showBirthPlace: boolean;
} = createSelector(
  getApplicantDocument,
  ({
    applicant: { citizenship, birthPlace },
  }: {
    applicant: ApplicantFields;
  }) => ({ citizenship: getValue(citizenship), birthPlace }),
  (document, { citizenship, birthPlace }) => {
    return {
      ...document,
      citizenship,
      birthPlace,
      showBirthPlace: true,
      model: APPLICANT,
    };
  }
);

export default connect(mapStateToProps)(ApplicantDocument);
